import { render, staticRenderFns } from "./expoCar.vue?vue&type=template&id=2c4a6b9f&scoped=true"
import script from "./expoCar.vue?vue&type=script&lang=js"
export * from "./expoCar.vue?vue&type=script&lang=js"
import style0 from "./expoCar.vue?vue&type=style&index=0&id=2c4a6b9f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4a6b9f",
  null
  
)

export default component.exports